import 'bootstrap/dist/css/bootstrap.min.css';
export const moduleName = 'reactstrap';

const reduxModule: IReduxModule = {
    moduleName,
};

export default reduxModule;


// WEBPACK FOOTER //
// ./src/redux/plugins/reactstrap/entry.tsx